import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';

@Component({
  selector: 'app-helping-detail-article-page',
  templateUrl: './helping-detail-article-page.component.html',
  styleUrls: ['./helping-detail-article-page.component.scss'],
})
export class HelpingDetailArticlePageComponent implements OnInit {
  articleID = 0;
  tagID = 0;
  page = 0;
  constructor(
    private api: MarketingApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.articleID = parseInt(
      this.route.snapshot.paramMap.get('article') || '0'
    );
    this.tagID = parseInt(this.route.snapshot.paramMap.get('tag') || '0');
    this.page = parseInt(this.route.snapshot.paramMap.get('p') || '0');
  }

  ngOnInit(): void {
    this.findArticles(this.tagID);
    this.getArticle(this.articleID);
  }

  back() {
    this.router.navigate([`/helping/detail/${this.tagID}`]);
  }

  articles: any[] = [];

  loading = false;
  async findArticles(id: number) {
    try {
      const r = await this.api.findArticlesTag(id, this.page + 1, 5);
      this.articles = r.data.list;
    } catch (error) {
    } finally {
    }
  }

  article: any;
  async getArticle(id: number) {
    try {
      this.loading = true;
      const r = await this.api.findArticles('', id, 1, 10);
      this.article = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  gotoArticle(id: number) {
    this.articleID = id;
    this.router.navigate([
      `/helping/detail/${this.tagID}/p/${this.page}/article/${id}`,
    ]);
    this.getArticle(id);
  }
}
